import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=29e2b272&scoped=true&"
import script from "./forgot_password.vue?vue&type=script&lang=js&"
export * from "./forgot_password.vue?vue&type=script&lang=js&"
import style0 from "./forgot_password.vue?vue&type=style&index=0&id=29e2b272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2b272",
  null
  
)

export default component.exports